import { API_URL } from '../constants';
import fetchAuthorization from './fetchAuthorization';
import { getErrorMessage } from '../helpers';

export async function fetchUSLacrosse(member_id: string): Promise<any> {
  try {
    const response = await fetchAuthorization(`${API_URL}us_lacrosse?member_id=${member_id}`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });

    const result = await response.json();

    if (response.status !== 200) {
      const message = getErrorMessage(result);
      throw new Error(message ? message : `Status Code: ${response.status}. Something went wrong. Please try again later.`);
    }

    return result;
  } catch (e: any) {
    throw new Error(`Unable to add the US Lacrosse Data. Error message: ${e.message}`);
  }
}

export default fetchUSLacrosse;
